
import React from 'react';
import ReactDOM from 'react-dom'; //구버전
// import { createRoot } from 'react-dom/client';
import App from './App';

ReactDOM.render(
    <React.StrictMode>
          <App />
    </React.StrictMode>,
    document.getElementById('root')
  );

